import { motion } from "framer-motion";

const skills = [
    { name: "React", level: 80, icon: "⚛️" },
    { name: "JavaScript", level: 95, icon: "JS" },
    { name: "CSS", level: 90, icon: "🎨" },
    { name: "Next.js", level: 80, icon: "▲" },
    { name: "Framer Motion", level: 85, icon: "✨" },
];

export default function Skills() {
    return (
        <section id="about">
            <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="project-title"
            >
                Technical Excellence
            </motion.h2>
            <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="title-para"
            >
                My expertise lies in building responsive, efficient, and scalable frontend architectures.
            </motion.p>

            <div className="grid">
                {skills.map((skill, index) => (
                    <motion.div
                        key={skill.name}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.1 }}
                        className="card"
                    >
                        <div className="card-content">
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                <span style={{ fontWeight: 700 }}>{skill.icon} {skill.name}</span>
                                <span style={{ color: 'var(--primary)', fontWeight: 600 }}>{skill.level}%</span>
                            </div>
                            <div style={{
                                height: '8px',
                                background: 'rgba(255,255,255,0.05)',
                                borderRadius: '4px',
                                overflow: 'hidden'
                            }}>
                                <motion.div
                                    initial={{ width: 0 }}
                                    whileInView={{ width: `${skill.level}%` }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 1, delay: 0.5 + (index * 0.1) }}
                                    style={{
                                        height: '100%',
                                        background: 'linear-gradient(to right, var(--primary), var(--secondary))'
                                    }}
                                />
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
